import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import BaiscModal from "../ModalsForBall/Modal";
import { Container, CircularProgress } from "@mui/material";

const SecurePage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const lotteryId = queryParams.get("lotteryId");
   const offset = queryParams.get("offset");
  useEffect(() => {
    const popupParam = queryParams.get("popup");
    if (popupParam === "true") {
      setIsModalOpen(true);
    }
  }, [location.search, navigate]);

  return (
    <Container>
      <BaiscModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        token={token}
        lotteryId={lotteryId}
        offset={offset}
      />
    </Container>
  );
};

export default SecurePage;
